import { combineReducers } from "redux";
import { chatReducer } from "./chatReducer";

const DEFAULT_STATE = { data: null, loading: true };

const currentUser = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "LOGOUT_SUCCESS":
      return { ...state, loading: false, data: null };
    case "DONE_LOADING":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default combineReducers({
  currentUser,
  chat: chatReducer
});



// WEBPACK FOOTER //
// client/redux/reducers.js